export default __webpack_public_path__ + "b868656d2e2a6ea265e05bb4ca43d257.svg";